import { render, staticRenderFns } from "./ModifyPrivateSpace.vue?vue&type=template&id=784af5da"
import script from "./ModifyPrivateSpace.vue?vue&type=script&lang=js"
export * from "./ModifyPrivateSpace.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports